import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";

import {
  customerEmailNotFoundSelector,
  customerEmailSelector,
  fetchCustomerByEmail,
  resetEmailError,
  setEmail,
  setEmailError,
} from "../../redux/slices/customer";
import { emailRegex } from "../../constants/regex";
import { getFromLocalStorage } from "../../utils/browser.utils";
import { getMattressConfigurationFromLocalStorage } from "../../utils/bedBuilder.utils";
import {
  setIsSaveForLaterModalOpen,
  setSaveForLaterModalSeen,
} from "../../redux/slices/customNavigation";
import { setMattressGlobalState } from "../../redux/slices/mattressConfiguration";
import ContainedButton from "../Buttons/ContainedButton";
import InputTitle from "../TextComponents/InputTitle";
import ModalSubtitle from "../TextComponents/ModalSubtitle";
import ModalTitle from "../TextComponents/ModalTitle";
import TextInput from "../Inputs/TextInput";

import EvrbedModal from "./EvrbedModal";
import ExitButton from "./ExitButton";

const SaveForLaterModal = ({ open, toggleModal }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const email = useSelector(customerEmailSelector);
  // console.log("=>(SaveForLaterModal.js:34) email", email);
  const emailNotFound = useSelector(customerEmailNotFoundSelector);
  // console.log("=>(SaveForLaterModal.js:36) emailNotFound", emailNotFound);

  const title = t("Save Your evrbed For Later!");
  const subTitle = t(
    "Save your evrbed now so you don't have to start over later."
  );
  const linkText = t("I'LL DO THIS LATER");
  const inputLabel = t("Email address");
  const dispatch = useDispatch();
  const handleCreateCustomer = async email => {
    dispatch(setEmail(email));
    let localStorageConfigExists = false;
    //Check Local Storage
    const localStorageMattressConfiguration =
      getMattressConfigurationFromLocalStorage();
    // console.log(
    //   "LOCALSTORAGE MATTRESS CONFIGURATION",
    //   localStorageMattressConfiguration
    // );
    if (localStorageMattressConfiguration !== null) {
      localStorageConfigExists = true;
      dispatch(
        setMattressGlobalState(JSON.parse(localStorageMattressConfiguration))
      );
    }
    // Search for client in Shopify
    dispatch(fetchCustomerByEmail({ email, localStorageConfigExists }));
    //Create customer if non-existent
    toggleModal(true);
  };

  const isEmailValid = email => {
    return emailRegex.test(email);
  };

  const handleOnChange = email => {
    // if (!isEmailValid(email)) {
    //   dispatch(setEmailError(true));
    // } else {
    //   dispatch(resetEmailError());
    // }
    dispatch(setEmail(email));
  };

  return (
    <EvrbedModal
      title={title}
      open={open}
      toggleModal={toggleModal}
      styles={{
        width: "32vw",
        height: "50vh",
        minHeight: "440px",
        paddingTop: "2vh",
        borderRadius: "110px 0px",
        background: "white",
      }}
    >
      <div
        className="flex justify-content-center text-center"
        style={{
          padding: "2rem",
          boxSizing: "border-box",
          width: "32vw",
          height: "45vh",
        }}
      >
        <ExitButton
          onClick={state => {
            dispatch(setIsSaveForLaterModalOpen(state));
            dispatch(setSaveForLaterModalSeen(true));
          }}
        ></ExitButton>
        <ModalTitle className="" styles={{ paddingLeft: "1vw" }}>
          {title}
        </ModalTitle>
        <ModalSubtitle
          className=""
          styles={{
            marginTop: "1rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            fontWeight: "400",
          }}
        >
          {subTitle}
        </ModalSubtitle>

        <InputTitle
          styles={{
            marginTop: "4rem",
            paddingLeft: "25%",
            textAlign: "left",
          }}
        >
          {inputLabel}
        </InputTitle>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-end",
            paddingRight: "29%",
          }}
        >
          <div className="flex justify-content-start" style={{}}>
            <TextInput
              label={"Email"}
              error={emailNotFound}
              value={email}
              onChange={value => handleOnChange(value)}
              styles={{
                marginTop: "1rem",
                backgroundColor: theme.COLORS.BLUE.lightBlue,
                borderColor: theme.COLORS.GREY.borderGrey,
                width: "100%",
              }}
            />
          </div>
          <div className="flex row justify-content-end mt-4">
            <ContainedButton
              className="col-auto"
              styles={{
                fontSize: "1rem",
              }}
              onClick={() => handleCreateCustomer(email)}
            >
              {t("SAVE MATTRESS")}
            </ContainedButton>
            <Link to="" style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                className="mt-2 text-end"
                onClick={toggleModal}
                style={{
                  color: theme.COLORS.BLUE.darkBlueGreen,

                  borderColor: "transparent",
                  textDecoration: "underline",
                  fontSize: "0.7rem",
                  fontFamily: "noto-sans",
                }}
              >
                {linkText}
              </button>
            </Link>
          </div>
        </div>
        {/*  See why our customers love us button*/}
        {/*  WhyEvrbed button*/}
      </div>
    </EvrbedModal>
  );
};

export default SaveForLaterModal;
